import React from "react";
import { Table } from "react-bootstrap";
import ToggleBar from "../../commoncomponents/toggleBar";
import { utcToDDMMYYYY, dayToHour } from "../../../utils/dateConvert";
import { rounding } from "../../../utils/math";
import { downloadCSVFile } from "../../../api/apiClient";
import ShowIButtonName from "../../commoncomponents/showIButtonName";
import moment from "moment";

function TotalSummary(props) {
  const report = props.reportDetails;
  let assetName= props.assetCustomerName;
  let timeZone = localStorage.getItem('timeZone');
  const trimMiliseconds = (num)=>{
    let str= ''+ num;
    if(str.includes('.')){

      // alert(str)
      let lastNum = str.lastIndexOf('.');
      let newNum = str.slice(0,lastNum);
      return newNum;
    }
    return str
  }

  const data = (
    <Table responsive striped>
      <thead>
        <tr className="nowwrapTH">
          <th>Asset</th>
          <th>Depot</th>
          <th>Timezone</th>
          <th>Start Date</th>
          <th
            style={{
              width: "150px",
              minWidth: "150px",
              whiteSpace: "nowrap",
            }}
          >
            End Date
          </th>
          <th>Total Days</th>
          <th>Days in use</th>
          <th>Utilisation</th>
          <th>Trips</th>
          <th>Virtual Trips</th>
          <th>
            All Trips&nbsp;
            <i
              class="fa fa-info-circle text-primary"
              title="First Engine ON to Last Engine OFF"
            ></i>
          </th>
          {/* <th>
            Duration&nbsp;{" "}
            <i
              class="fa fa-info-circle text-primary"
              title="First Engine ON to Last Engine OFF"
            ></i>
          </th>
          <th>
            Duration Outside Depot&nbsp;{" "}
            <i
              class="fa fa-info-circle text-primary"
              title="First Departure until Last Entry or Engine OFF"
            ></i>
          </th> */}
          <th>Engine Hours</th>
          <th>
            Moving Engine Hours&nbsp;{" "}
            <i
              class="fa fa-info-circle text-primary"
              title="Engine Hours - Virtual Parked"
            ></i>
          </th>
          <th>Idling Hours</th>
          <th>
            Moving Engine Hours Outside&nbsp;{" "}
            <i
              class="fa fa-info-circle text-primary"
              title="Total moving engine hours outside depot"
            ></i>
          </th>
          <th>Parked</th>
          <th>
            Total Parked &nbsp;
            <i
              class="fa fa-info-circle text-primary"
              title="Parked + Virtual Parked"
            ></i>
          </th>
          <th>Distance</th>
          {/* <th>
            Average Journey&nbsp;{" "}
            <i
              class="fa fa-info-circle text-primary"
              title="Engine Hours / All Trips"
            ></i>
          </th>
          <th>
            Average Parked &nbsp;
            <i
              class="fa fa-info-circle text-primary"
              title="Total Parked / All Trips"
            ></i>
          </th>
          <th>
            Average Distance &nbsp;
            <i
              class="fa fa-info-circle text-primary"
              title="Distance / All Trips"
            ></i>
          </th> */}
          <th>Parked Idle</th>
          <th>Duress</th>
          <th>Powercut</th>
          <th>Low Battery</th>
          <th>Temp A</th>
          {report.tempB > 0 && <th>Temp B</th>}
          <th>Overspeed</th>
          <th>Harsh Accel</th>
          <th>Harsh Brake</th>
          <th>Harsh Corner</th>
          <th>OH&S</th>
          <th>GSM Loss</th>
          <th>GPS Loss</th>
          <th>Processed</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            {report.asset}
            <br />
            <ShowIButtonName
              ibuttonId={report.ibuttonId}
              serialno={report.serialno}
              iButtonName={report.iButtonName}
            />
          </td>
          <td>{report.depot}</td>
          <td>{report.timezone}</td>
          <td style={{ whiteSpace: "nowrap" }}>
            {utcToDDMMYYYY(report.startDate)}
          </td>
          <td
            style={{
              width: "100",
              minWidth: "100",
              whiteSpace: "nowrap",
            }}
          >
            {moment(report.endDate).format("DD-MM-YYYY")}
          </td>
          <td>{report.totalDays}</td>
          <td>{report.daysInUse}</td>
          <td>{report.utilisation}%</td>
          <td>{report.trips}</td>
          <td>{report.virtualTrips}</td>
          <td>{report.allTrips}</td>
          {/* <td>{dayToHour(report.duration)}</td>
          <td>{dayToHour(report.durationOutsideDepot)}</td> */}
          <td>{dayToHour(report.engineHours)}</td>
          <td>{dayToHour(report.movingEngineHours)}</td>
          <td>{dayToHour(report.idlingHours)}</td>
          <td>{dayToHour(report.movingEngineHoursOutside)}</td>
          <td>{dayToHour(report.parked)}</td>
          <td>{dayToHour(report.totalParked)}</td>
          <td>{trimMiliseconds(report.distance)}</td>
          {/* <td>{trimMiliseconds(report.averageJourney)}</td>
          <td>{trimMiliseconds(report.averageParked)}</td>
          <td>{rounding(report.averageDistance)}</td> */}
          <td>{report.parkedIdle}</td>
          <td>{report.duress}</td>
          <td>{report.powercut}</td>
          <td>{report.lowBattery}</td>
          <td>{report.tempA}</td>
          {report.tempB > 0 && <td>{report.tempB}</td>}
          <td>{report.speed}</td>
          <td>{report.harshAccel}</td>
          <td>{report.harshBrake}</td>
          <td>{report.harshCorner}</td>
          <td>{report.ohs}</td>
          <td>{report.gsmLoss}%</td>
          <td>{report.gpsLoss}%</td>
          <td>{report.processed}</td>
        </tr>
      </tbody>
    </Table>
  );
  const handleDownloadExcel = () => {
    // alert("clicked")
    let reportArr = [];

    reportArr.push(props.reportDetails);
    console.log("ss props.reportDetails",reportArr);

    downloadCSVFile(reportArr,"AssetRunning_TotalSummary",assetName,timeZone);
  };
  return (
    <ToggleBar
      caption="Total Summary"
      download={handleDownloadExcel}
      icon="fa-bar-chart"
      color="#337AB7"
      content={data}
    />
  );
}

export default TotalSummary;
